import React from "react"

import Expand from "./../../images/expand.svg"
import {
  Item,
  Container,
  Header,
  Icon,
  Line,
  Title,
  Button,
  Close,
  Content,
} from "./styles.js"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

class AccordionItem extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
    }
  }

  onClickHandler = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

  render() {
    return (
      <Item>
        <Container>
          <Header>
            <Title>
              <Icon>
                <FontAwesomeIcon icon={this.props.data.data.icon.text} />
              </Icon>
              <Line />
              {this.props.data.data.title.text}
            </Title>
            <Button onClick={this.onClickHandler} active={this.state.isOpen}>
              <Close src={Expand} />
            </Button>
          </Header>
          <Content
            active={this.state.isOpen}
            dangerouslySetInnerHTML={{
              __html: this.props.data.data.content.html,
            }}
          />
        </Container>
      </Item>
    )
  }
}

export default AccordionItem
